import { Breadcrumb } from 'antd';

import styled, { css } from '@/styled';

export default styled(Breadcrumb)(
  ({ theme }) => css`
    position: relative;
    margin-bottom: ${theme.space.pxToRem(24)};

    ${theme.breakpoints.down('md')} {
      display: none;
    }

    .courseTitle {
      color: ${theme.colorTextTertiary};
    }

    .ant-breadcrumb-link {
      cursor: pointer;
    }

    .ant-typography {
      margin: 0;
      font-size: ${theme.space.pxToRem(14)};
    }
  `
);
